export default function TestDocumentsController() {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;
  vm.canEdit = true;
}

TestDocumentsController.$inject = [];
